import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createPlatePlugin, useEditorRef } from '@udecode/plate/react';
import styled from 'styled-components';
import { Badges } from '../Badges';
import { Stack } from '../Layout';
import { theme } from '../theme';
import { useMarkdownProps } from './context';
import { InsertImageButton } from './InsertImageButton';
import { LinkButton } from './LinkPlugin';
import { OrderedListButton, UnorderedListButton } from './List';
import { StyledFixedToolbar } from './styled';
import { TableActions } from './TableActions';
import { TextTypeSelect } from './TextTypeSelect';
import { BoldButton, UnderlineButton, ItalicButton, CodeBlockButton } from './ToolbarComponents';
import { PluginType } from './types';
const VerticalSeparator = styled.hr`
  background-color: ${theme.colors.gray300};
  border: none;
  box-shadow: none;
  height: ${theme.spaces.x24};
  width: ${theme.spaces.x1};
`;
const ToolbarActions = styled(Stack)`
  ${({ $disabled })=>$disabled && `
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  `}
`;
const ReadOnlyBadge = styled(Badges)`
  height: auto;
  line-height: 1.1;
  max-height: 90%;
`;
function FixedToolbar() {
    const { customTools, supportedPluginTypes, readOnly } = useMarkdownProps();
    const editor = useEditorRef();
    const renderedCustomTools = typeof customTools === 'function' ? customTools(editor) : customTools;
    return /*#__PURE__*/ _jsxs(StyledFixedToolbar, {
        direction: "horizontal",
        alignY: "center",
        align: "space-between",
        children: [
            /*#__PURE__*/ _jsxs(ToolbarActions, {
                direction: "horizontal",
                gap: theme.spaces.x4,
                alignY: "center",
                $disabled: readOnly,
                children: [
                    supportedPluginTypes.has(PluginType.TextType) && /*#__PURE__*/ _jsx(TextTypeSelect, {}),
                    supportedPluginTypes.has(PluginType.Bold) && /*#__PURE__*/ _jsx(BoldButton, {}),
                    supportedPluginTypes.has(PluginType.Italic) && /*#__PURE__*/ _jsx(ItalicButton, {}),
                    supportedPluginTypes.has(PluginType.Underline) && /*#__PURE__*/ _jsx(UnderlineButton, {}),
                    supportedPluginTypes.has(PluginType.Link) && /*#__PURE__*/ _jsx(LinkButton, {}),
                    supportedPluginTypes.has(PluginType.Code) && /*#__PURE__*/ _jsx(CodeBlockButton, {}),
                    supportedPluginTypes.has(PluginType.Image) && /*#__PURE__*/ _jsx(InsertImageButton, {}),
                    supportedPluginTypes.has(PluginType.List) && /*#__PURE__*/ _jsx(UnorderedListButton, {}),
                    supportedPluginTypes.has(PluginType.List) && /*#__PURE__*/ _jsx(OrderedListButton, {}),
                    supportedPluginTypes.has(PluginType.Table) && /*#__PURE__*/ _jsx(TableActions, {}),
                    renderedCustomTools && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(VerticalSeparator, {}),
                            renderedCustomTools
                        ]
                    })
                ]
            }),
            readOnly && /*#__PURE__*/ _jsx(ReadOnlyBadge, {
                size: "s",
                tone: "yellow",
                children: "Read only"
            })
        ]
    });
}
export const FixedToolbarPlugin = createPlatePlugin({
    key: 'fixed-toolbar',
    render: {
        beforeEditable: ()=>/*#__PURE__*/ _jsx(FixedToolbar, {})
    }
});
